export default {
  v3OfficialTopUpCenterTitle: 'Official Top-up Center',
  v3OfficialTopUpCenterKeyword: 'Official Top-up Center',
  v3OfficialTopUpCenterDescription: 'Official Top-up Center',
  v3SafeAndFast: 'Safe, Risk-free, and Instantly Credited',
  v3Shop: 'Mall',
  v3ShoppingCart: 'Shopping Cart',
  v3MembershipCenter: 'Privilege Center (Premium Member Center)',
  v3Login: 'Login',
  v3Account: 'Account',
  v3EnterAccountName: 'Enter Account Name',
  v3Password: 'Password',
  v3EnterPassword: 'Enter Password',
  v3ForgotPassword: 'Forgot Password',
  v3EnterUID: 'Enter UID',
  v3OTP: 'OTP',
  v3EnterOTP: 'Please enter OTP',
  v3SelectTopUpCharacter: 'Select top-up character',
  v3SelectServer: 'Select Server',
  v3Confirm: 'Confirm',
  v3CharacterNotFound:
    "If you can't find the character, try logging into the character in the game first, then log into the top-up page or contact customer service.",
  v3Logout: 'Log out',
  v3SwitchAccount: 'Switch Account',
  v3MyCoupons: 'My Coupons',
  v3BenefitsCenter: 'Premium Member Center',
  v3TopUpBenefits: 'Top-up Benefits',
  v3MoreSettings: 'More Settings',
  v3RememberLoginStatus: 'Remember my login status',
  v3OrderQuery: 'Check Orders',
  v3ContactCustomerService: 'Customer Service',
  v3LoginWithApp: 'Log in via App',
  v3ChooseOtherLoginMethod: 'Select an alternate login method',
  v3ConnectingToGameApp: 'Connecting to the game app',
  v3EnsureGameInstalled:
    'Please make sure the game is installed on this device. If the game is not responsive or login fails, update the games to the latest version from the app store or switch to another browser.',
  v3OpenGame: 'Launch Game',
  v3DownloadGame: 'Download Game',
  v3UpdateGameIfOpenFails:
    'If the game fails to launch, please update it to the latest version from App Store/Google Play.',
  v3ClickToDownloadLatestVersion:
    'Alternatively, you can hit the download game button to get the latest version.',
  v3LoggingIntoOfficialTopUpCenter:
    'You are logging into the [Official Top-up Center]',
  v3CurrentAccount: 'Current account: xxxxxxxxxx',
  v3WelcomeToOfficialTopUpCenter: 'Welcome to the Official Top-up Center',
  v3OfficialAuthorizedLogin: 'Officially authorized login. No security risks.',
  v3TermsOfService: 'Terms of Service',
  v3PrivacyPolicy: 'Privacy Policy',
  v3ThirdPartySocialAccountDescription:
    'About Third-party Social Media Account',
  v3BindSocialAccountInGameFirst:
    'Please complete binding your social media account in the in-game User Center first, then log in with the bound social media account.',
  v3FirstTopUp15PercentOff: 'Enjoy up to 15% OFF on your first top-up',
  v3MoreTopUpRebates: 'More top-up rebates and rewards',
  v3LoginToViewOffers: 'Log in to view discounts',
  v3TopUpEnvironmentChecking: 'Verifying top-up environment...',
  v3SafeToUse: 'Safe and secure.',
  v3LimitedTimeBenefits: 'Exclusive Limited-Time Offer',
  v3EventRules: 'Event Rules',
  v3MoreEvents: 'More Events',
  v3Claim: 'Claim',
  v3Completed: 'Completed',
  v3GoTo: 'Go',
  v3ViewDetails: 'View Details',
  v3RecommendedProducts: "Recom'd Items",
  v3SearchProductName: 'Search by item name',
  v3AllCategories: 'All',
  v3PopularSort: 'Hot',
  v3PriceAscending: 'Price ↑',
  v3PriceDescending: 'Price ↓',
  v3DiamondBonus10Percent: 'Diamond +10%',
  v3YuanbaoBonus10Percent: 'Ingot +10%',
  v3ExtraBonus10Percent: 'Bonus: 10%',
  v3FirstTopUpDouble: '1st Top-up Doubled',
  v3FirstExtraBonus: '1st-Time Bonus',
  v3ProductDetails: 'Product Details',
  v3AddToCart: 'Add to Cart',
  v3AddedToCart: 'Added to Cart',
  v3BuyNow: 'Buy Now',
  v3NoItemsInCart: 'No items in your cart yet',
  v3SelectedItemsN: 'Selected items: (${n})',
  v3RemoveFromCart: 'Remove from cart?',
  v3Yes: 'Yes',
  v3No: 'No',
  v3LimitOnePerPurchase: 'Only one of this item can be purchased at a time',
  v3ItemPrice: 'Item Price',
  v3Tax: 'Tax',
  v3ExtraGift: 'Bonus',
  v3Total: 'Total',
  v3ProceedToPayment: 'Pay',
  v3SelectCoupon: 'Select Coupon',
  v3UnavailableCoupons: 'Unusable Coupons',
  v3OneCouponPerOrder: 'One coupon per order',
  v3DiscountCoupon: 'Discount Coupon',
  v3ThresholdCoupon: 'Deduction Coupon',
  v3MinSpendCoupon: 'Usable when total price over xx USD',
  v3MaxDiscountCoupon: 'Discount up to xxxx USD',
  v3LimitedChannel: 'Limited to specific channels',
  v3AllChannels: 'Available for all channels',
  v3SpecificProducts: 'Specific items only',
  v3AllProducts: 'For all items',
  v3NotYetTimeToUse: 'Not usable yet',
  v3Expired: 'Expired',
  v3Used: 'Used',
  v3ValidityPeriod: 'Validity: ',
  v3ConfirmUse: 'Confirm',
  v3ChangeProduct: 'Change Item',
  v3ConfirmPaymentOrder: 'Confirm Order',
  v3StoredValueRole: 'Top-up Character',
  v3TotalNProducts: 'Total items: ${n}',
  v3SelectPaymentMethod: 'Select Payment Method',
  v3PayNow: 'Pay Now',
  v3MorePaymentMethods: 'More Payment Methods',
  v3NoAvailablePaymentMethodContactSupport:
    "Can't find any available payment methods? Contact Customer Service.",
  v3AvailableCoupons: 'Usable Coupons',
  v3Extra10Percent: '*+10%',
  v3LastSelection: 'Previous Choice',
  v3RecommendedUsage: 'Recommended',
  v3PopularChoice: 'Popular Choice',
  v3PaymentSuccess: 'Payment Done',
  v3PaymentFailure: 'Failed to pay',
  v3TopUpFailureMessage:
    'Sorry, top-up failed. Please try resubmitting your order or contact customer service.',
  v3Game: 'Game',
  v3UID: 'UID',
  v3OrderNumber: 'Order No.',
  v3ProductContent: 'Item Details',
  v3ViewProductDetails: 'View Item Details',
  v3PaymentMethod: 'Payment Method',
  v3Complete: 'Complete',
  v3TopUpAgain: 'Top Up Again',
  v3FriendlyReminderSaveOrderInfo:
    'Reminder: Save your order info by screenshot for faster processing.',
  v3RechargeAgain: 'Top Up Again',
  v3TransactionInProgress: 'Processing transaction',
  v3CompletePaymentInChannel:
    'Please proceed to the payment channel to complete the payment.',
  v3RestAssuredFastDeliveryAfterPayment:
    'Item will be sent to you once payment result is received.',
  v3SaveOrderInfoForProgress:
    'You can take a screenshot of the order information for tracking the transaction progress.',
  v3PaymentCompleted: 'Payment has been completed',
  v3AddToHomeScreen: 'Add to Home Screen',
  v3AddShortcutForBonus: 'Add a shortcut to receive additional rewards',
  v3ShareSuccess: 'Shared',
  v3ShareFailure: 'Failed to share',
  v3RewardClaimed: 'Reward Claimed',
  v3RewardClaimFailed: 'Failed to claim reward',
  v3EventNotStarted: "Event hasn't started yet",
  v3EventEnded: 'Event is over',
  v3ClickSelectCoupon: 'Click to select coupon',
  v3CouponsRecommendedUsed: 'Recommended coupon used',
  v3CouponsSelected: 'Coupon selected',
  v3NoCouponsAvaliable: 'No available coupon',
  v3SupplementStatus: 'Status',
  v3SupplementNormal: 'Normal',
  v3SupplementBanned: 'Banned',
  v3SupplementPendingPayment: 'Pending Payment',
  v3SupplementSwitchCharacter: 'Switch Character',
  v3SupplementAccountInfoInvalid: 'Account Info Invalid',
  v3SupplementContactGSForTopUpLink: 'Please contact GS for top-up link',
  v3SupplementTopUpCompleted: 'Top-up Completed:',
  v3SupplementTotalRefundOrders: 'Total {} refund orders',
  v3SupplementPendingSupplementAmount: 'Pending Payment Amount:',
  v3SupplementAccountCharacterNormalNoPaymentNeeded:
    'Account/Character normal, no payment needed',
  v3SupplementEnjoyYourGame: 'Enjoy your game!!',
  v3SupplementOrderInformation: 'Order Information',
  v3SupplementPendingPaymentAmount: 'Pending Payment Amount:',
  v3LookUpCouponRule: 'Check Coupon Distribution Rules',
  v3SwitchOldVersion: 'Switch to Old Payment Platform',
  v3FirstTopUpGiveaway: '1st Top-up Bonus',
  v3SecureConnection: 'Establishing secure connection',
  v3RequestTimeOut: 'Loading timed out, please try again later.',
  v3ConfirmLeave: 'Exit?',
  v3NoSubmitOrder:
    'Your cart is not yet checked out, you may miss your desired items if you leave.',
  v3ContinueSubmit: 'Continue',
  v3LeaveSubmit: 'Leave',
  v3RecentBug: 'Recently Bought',
  v3ScanCodeLogin: 'Scan Code Login',
  v3BindRole: 'Bind Role',
  v3ScanLoading: 'loading...',
  v3ScanExpired: 'QR code expired',
  v3ScanRefreshClick: 'Click to refresh',
  v3ScanRefreshTip: 'Please refresh and scan again',
  v3ScanRefresh: 'Refresh',
  v3ScanSucc: 'Scanned successfully',
  v3ScanAuth: 'Please confirm on your phone',
  v3ScanAuthSuccess: 'Authorization successful',
  v3ScanAuthSuccessTip: 'Logging in...',
  v3ScanUnauthorized: 'Authorization failed',
  v3ScanRefreshTip2: 'Log in to the game app to scan',
  v3ScanGuide: 'Scan Guide',
  v3ScanLoginError: 'Login error, please refresh and retry',
  v3PwaTapShareOrMenuIcon: 'Tap the Share or Menu icon in the browser toolbar',
  v3PwaFindAndTapAddToHomeScreen:
    'Find and tap "Add to Home Screen" in the options',
  v3ThirdPartyLogin: 'Third-party Login',
  v3NoMyLoginMethod: "Don't have my login method?",
  v3AccountPasswordLogin: 'Please enter account to bind game character',
  v3LaunchFromDesktopAndRewardToMailbox: 'Please launch from the desktop\nSelect a character and the reward will be sent to your mailbox',
  v3ClaimSuccessCheckMailbox: 'Claim Successful\nPlease check your in-game mail',
  v3ExclusiveProductTip: 'This item is already in your cart.\nPlease remove it before adding again.',
  v3LifeLimitProductTip: 'This product cannot be added to the shopping cart multiple times. \nOnly one unit can be added at a time.',
  v3Notice: 'Notice',
  v3LifeLimitAddToCartTip: '<span style="font-weight: bold;text-decoration: underline;">【productName】is limited to one purchase per lifetime.</span>\nOnly the first successfully paid order will grant【productName】\nIf additional successful payments occur, from the second order onward, <span style="font-weight: bold;text-decoration: underline;;">【191999星石】</span>will be granted instead.',
  v3LifeLimitCancelAddToCart: 'Remove from shopping cart',
  v3LifeLimitConfirmAddToCart: 'Confirm and continue',
  v3LifeLimitCancelBuy: 'Cancel purchase',
  v3LifeLimitSubmitProductContent: 'Your shopping cart contains the product <span style="font-weight: bold;text-decoration: underline;">【productName】</span>\n<span style="font-weight: bold;text-decoration: underline;">This product is limited to one purchase per lifetime.</span>\nOnly the first successfully paid order will grant 【productName】.\n<span style="font-weight: bold;text-decoration: underline;">If additional successful payments occur, from the second order onward,【191999星石】 will be granted instead.</span>',
  v3NoAvailableProducts: 'No items available for the current character.\n Please select a character of Level 10 or above and ensure the character is online.',
};
